module.exports = __webpack_public_path__ + "static/media/Heater.8e7dbafa.svg";